import { connect } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { addMediaToTier } from '../redux/creator/actions';
import { ModalType } from '../../Modals/redux/types';
var mapStateToProps = function (state, ownProps) { return ({}); };
var mapDispatchToProps = function (dispatch, ownProps) { return ({
    addMediaToTier: function (deviations) {
        dispatch(addMediaToTier({ deviations: deviations, tierDeviation: ownProps.tierDeviation }));
    },
    pushLoadingModal: function () {
        dispatch(pushModal(ModalType.LOADING_SCREEN, { wrapInModal: false }));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=TierManageContentButton.container.js.map